import { useEffect, useState } from 'react';

export const useTransition = (
  externalOpen: boolean,
  cb?: () => void,
  duration = 50
) => {
  const [open, setOpen] = useState(externalOpen);
  const [internalOpen, setInternalOpen] = useState(externalOpen);

  useEffect(() => {
    if (externalOpen) {
      setOpen(true);
      setTimeout(() => {
        setInternalOpen(true);
      }, 10);
    } else {
      setOpen(false);
      setTimeout(() => {
        setInternalOpen(false);
      }, 500);
    }
  }, [externalOpen]);

  return {
    className: internalOpen && open ? 'expanded' : '',
    open: internalOpen || open,
    close: () => {
      setOpen(false);

      setTimeout(() => {
        setInternalOpen(false);
        cb?.();
      }, duration);
    }
  };
};
